"use strict";
exports.__esModule = true;
exports.EnvironmentEnum = void 0;
/**
 * Environment enum file
 */
var EnvironmentEnum;
(function (EnvironmentEnum) {
    EnvironmentEnum["uat"] = "https://api-uat.kushkipagos.com/";
    EnvironmentEnum["prod"] = "https://api.kushkipagos.com/";
    EnvironmentEnum["regionalUat"] = "https://regional-uat.kushkipagos.com/";
    EnvironmentEnum["regionalProd"] = "https://regional.kushkipagos.com/";
})(EnvironmentEnum = exports.EnvironmentEnum || (exports.EnvironmentEnum = {}));
